export function detectDarkTheme(): boolean {
  const themeInfo = Office.context.officeTheme;
  if (themeInfo?.bodyBackgroundColor) {
    return isDarkTheme(themeInfo.bodyBackgroundColor);
  }

  return !!window.matchMedia?.("(prefers-color-scheme: dark)").matches;
}

export function isDarkTheme(bgColor?: string): boolean {
  if (!bgColor) return false;

  // convert hex into RGB
  const hex = bgColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // formula for luminance (perceived brightness)
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // if luminance is less than 128, than theme should be dark
  return luminance < 128;
}
